import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { red, lightGreen } from "material-ui/colors";

const styles = theme => ({
  eulaExclamation: {
    color: red["500"],
    fontSize: 18
  },
  eulaCheck: {
    color: lightGreen["A700"],
    fontSize: 18
  },
  lightText: {
    color: "rgba(0, 0, 0, 0.54)"
  }
});

const EulaStatus = props => {
  const { classes, accepted } = props;

  if (accepted) {
    return (
      <Typography className={classes.lightText}>
        EULA Valid <span className={classes.eulaCheck}>✓</span>
      </Typography>
    );
  }
  return (
    <Typography className={classes.lightText}>
      EULA Out of date <span className={classes.eulaExclamation}>!</span>
    </Typography>
  );
};

EulaStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  accepted: PropTypes.bool
};

EulaStatus.defaultProps = {
  accepted: false
};

export { EulaStatus };

export default withStyles(styles, { name: "EulaStatus" })(EulaStatus);



// WEBPACK FOOTER //
// ./src/EulaStatus.js